// extracted by mini-css-extract-plugin
module.exports = {"callout":"DashboardStat_callout__2R5f4","subtext":"DashboardStat_subtext__2xgqQ","stat":"DashboardStat_stat___NxtG"};